/* tslint:disable */
import { defineMessages } from 'react-intl';

export default defineMessages({
    addToFavorites: {
        defaultMessage: 'Add to Favorites',
        id: 'components.addToFavorites',
    },
    removeFromFavorites: {
        defaultMessage: 'Remove from Favorites',
        id: 'components.removeFromFavorites',
    },
});
